import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import translate from "../services/Translation/lang";
import rocketmanTransport from "../services/RocketmanTransport";

const TOAST_AUTO_CLOSE = 10 * 1000; // toast duration
const TOAST_GRACE_PERIOD = 2000; // 2 seconds grace period

const InactivityToast = () => {
  const [toastVisible, setToastVisible] = useState(false);
  const toastVisibleRef = useRef(false);
  const inactivityTimeoutRef = useRef(null);
  const graceTimeoutRef = useRef(null);
  const ignoreActivityRef = useRef(false);
  const [rocketmanSessionPopup, setRocketmanSessionPopup] = useState(0)

  const sessionPopupValue = Number(rocketmanSessionPopup);
  const shouldEnableInactivityToast = sessionPopupValue > 0;
  const INACTIVITY_LIMIT = shouldEnableInactivityToast ? sessionPopupValue * 60 * 1000 : null;

  window.setRocketmanSessionPopup = setRocketmanSessionPopup;

  const showInactivityToast = () => {
    if (!toastVisibleRef.current) {
      toast.info(translate('your_session_is_about_to_expire'), {
        toastId: "inactivity-toast",
        autoClose: TOAST_AUTO_CLOSE,
        onClose: () => {
          setToastVisible(false);
          toastVisibleRef.current = false;
        },
      });
      setToastVisible(true);
      toastVisibleRef.current = true;

      ignoreActivityRef.current = true;
      graceTimeoutRef.current = setTimeout(() => {
        ignoreActivityRef.current = false;
      }, TOAST_GRACE_PERIOD);
    }
  };

  const resetInactivityTimer = () => {
    if (!shouldEnableInactivityToast || ignoreActivityRef.current) return;

    if (toastVisibleRef.current) {
      toast.dismiss("inactivity-toast");
      setToastVisible(false);
      toastVisibleRef.current = false;
    }

    clearTimeout(inactivityTimeoutRef.current);
    inactivityTimeoutRef.current = setTimeout(showInactivityToast, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    if (!shouldEnableInactivityToast) return;

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach(event => window.addEventListener(event, resetInactivityTimer));

    inactivityTimeoutRef.current = setTimeout(showInactivityToast, INACTIVITY_LIMIT);

    return () => {
      events.forEach(event => window.removeEventListener(event, resetInactivityTimer));
      clearTimeout(inactivityTimeoutRef.current);
      clearTimeout(graceTimeoutRef.current);
    };
  }, [shouldEnableInactivityToast, INACTIVITY_LIMIT]);

  return <ToastContainer />;
};

export default InactivityToast;
